import React, {useEffect, useState} from 'react'
import "./registerrefugee.css";
import { ethers } from 'ethers';
import {Box,Typography,TextField,Button} from '@mui/material'

const refugeecampABI = require("./../../refugeecampABI.json");
const CONTRACT_ADDRESS = "0x91013c098C93cb2E64189a8c4F6D97D4c9972907"


const RegisterRefugee = () => {
    const [refugeeAddress, setRefugeeAddress] = useState("");
    const [transactions, setTransactions] = useState([])
    const [contractListened, setContractListened] = useState();

    const registration = async () => {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        await provider.send("eth_requestAccounts", []);
        const signer = await provider.getSigner();
        const refugeecamp = new ethers.Contract(CONTRACT_ADDRESS, refugeecampABI, signer);
        await refugeecamp.register(refugeeAddress);
      }

      var transactionsTemp = [];

      // useEffect(() => {
      //     const provider = new ethers.providers.Web3Provider(window.ethereum);
      //     const refugeecamp = new ethers.Contract(CONTRACT_ADDRESS, refugeecampABI, provider);
      //     refugeecamp.on("RegistrationComplete", (person, event) => {
      //       transactionsTemp = [...transactionsTemp, person.substring(0, 5) + "..." + person.substring(37)];
      //       setTransactions(transactionsTemp);
      //      });
      //     setContractListened(refugeecamp);   
      //     return () => {
      //       contractListened.removeAllListeners();
      //     };
      //   }, []);

    return (
        <Box>
          <Box>
            <Box>
              <Box sx={{width:{sm:"80vw",md:"60vw"},display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",marginBottom:"5vh"}}>
                  <Typography variant="h4" color="primary">Register</Typography>
                  <Typography variant="p" >Register new refugees here</Typography>
              </Box>
              <Box sx={{width:{sm:"80vw",md:"60vw"},display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
                  <TextField label="Name" variant="outlined" fullWidth sx={{margin:"1vh"}} required/> 
                  <TextField label="Image URL" variant="outlined" fullWidth sx={{margin:"1vh"}}/> 
                  <TextField label="Father's Name" variant="outlined" fullWidth sx={{margin:"1vh"}}/> 
                  <TextField label="Mother's Name" variant="outlined" fullWidth sx={{margin:"1vh"}}/> 
                  <TextField type="text" value={refugeeAddress} label= "Refugee Address" fullWidth required onChange={(e)=>setRefugeeAddress( e.target.value )}/>
                  <Button variant="contained" onClick={registration} sx={{fontSize:20,marginTop:"2vh"}}> REGISTER </Button>
              </Box>
              <Box sx={{width:{sm:"80vw",md:"60vw"},display:"flex",alignItems:"center",justifyContent:"space-around",margin:"2vh"}}>
                  {/*<Button vatriant="contained" onClick={createQR} > Submit </Button>*/}
              </Box>
              <Box sx={{width:{sm:"80vw",md:"60vw"},display:"flex",alignItems:"center",justifyContent:"space-around",margin:"2vh"}}>
                
              </Box>
              
        
              
            </Box>
          </Box>
    
          <Box>
            {
              transactions.map((transaction)=> <Box>
                <h2>REGISTRATION COMPLETE</h2>
                <h3>Person Address</h3>
                <h1>{transaction}</h1>
              </Box>)
            }
          </Box>
        </Box>
        
      )
}

export default RegisterRefugee


// 0xdB0E43a6D1D97C9700c0861364383F13BEA97C2d  refugee